import { render, staticRenderFns } from "./EventKakaoFriend.vue?vue&type=template&id=390af139&"
import script from "./EventKakaoFriend.vue?vue&type=script&lang=js&"
export * from "./EventKakaoFriend.vue?vue&type=script&lang=js&"
import style0 from "./EventKakaoFriend.vue?vue&type=style&index=0&id=390af139&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports